
import {Dimension} from "../../dto/Options";
import {PDFDocument} from "PageBuilder/pagebuilder/PDFDocument";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {IPDFContainer} from "InternalShared/PageBuilder/Controls/Core/IPDFContainer";



export class DragHintManager{
    public GAP:number=1;
    public $topHint:JQuery;
    public $bottomHint:JQuery;
    public $leftHint:JQuery;
    public $rightHint:JQuery;
    constructor(public page:IPDFContainer)
    {

    }

    public ShowIfNeeded($element:JQuery,draggedElementDimension:Dimension):{top:number,left:number}
    {
        this.Clear();

        let topHint:HintInformation=null;
        let bottomHint:HintInformation=null;
        let rightHint:HintInformation=null;
        let leftHint:HintInformation=null;

        for(let element of this.page.components)
        {
            if(element.$element==$element)
                continue;
            let topDelta=this.GetVerticalDelta(draggedElementDimension.top,element);
            if(topDelta!==null){
                if(topHint==null||Math.abs(topDelta)<Math.abs(topHint.delta))
                    topHint={
                        element:element,
                        delta:topDelta
                    }

            }

            let bottomDelta=this.GetVerticalDelta(draggedElementDimension.top+draggedElementDimension.height,element);
            if(bottomDelta!==null){
                if(bottomHint==null||Math.abs(bottomDelta)<Math.abs(bottomHint.delta))
                    bottomHint={
                        element:element,
                        delta:bottomDelta
                    }

            }


            let leftDelta=this.GetHorizontalDelta(draggedElementDimension.left,element);
            if(leftDelta!==null){
                if(leftHint==null||Math.abs(leftDelta)<Math.abs(leftHint.delta))
                    leftHint={
                        element:element,
                        delta:leftDelta
                    }

            }

            let rightDelta=this.GetHorizontalDelta(draggedElementDimension.left+draggedElementDimension.width,element);
            if(rightDelta!==null){
                if(rightHint==null||Math.abs(rightDelta)<Math.abs(rightHint.delta))
                    rightHint={
                        element:element,
                        delta:rightDelta
                    }

            }
            

        }

        let additionalPixels={
            top:0,
            left:0
        };

        if(topHint!=null) {
            this.$topHint = this.ShowVerticalHint('top', $element, draggedElementDimension, topHint);
            additionalPixels.top=topHint.delta;
        }
        else if(bottomHint!=null) {
            this.$bottomHint = this.ShowVerticalHint('bottom', $element, draggedElementDimension, bottomHint);
            additionalPixels.top=bottomHint.delta;
        }

        if(leftHint!=null) {
            this.$leftHint = this.ShowHorizontalHint('left', $element, draggedElementDimension, leftHint);
            additionalPixels.left=leftHint.delta;
        }
        else if(rightHint!=null) {
            this.$rightHint = this.ShowHorizontalHint("right", $element, draggedElementDimension, rightHint);
            additionalPixels.left=rightHint.delta;
        }

        return additionalPixels;


    }


    private GetVerticalDelta(top:number, element: PDFControlBase) {
        let topDelta=top-element.latestDimension.top;
        if(Math.abs(topDelta)<=this.GAP)
            return topDelta;

        topDelta=top-element.latestDimension.top-element.latestDimension.height;
        if(Math.abs(topDelta)<=this.GAP)
            return topDelta;

        return null;
    }

    private GetHorizontalDelta(left:number, element: PDFControlBase) {
        let leftDelta=left-element.latestDimension.left;
        if(Math.abs(leftDelta)<=this.GAP)
            return leftDelta;

        leftDelta=left-element.latestDimension.left-element.latestDimension.width;
        if(Math.abs(leftDelta)<=this.GAP)
            return leftDelta;

        return null;
    }

    private ShowVerticalHint(position:'top'|'bottom',$element:JQuery,draggedElementDimension: Dimension, topHint: HintInformation) {
        let startLeft=Math.min(draggedElementDimension.left,topHint.element.latestDimension.left);
        let endLeft=Math.max(draggedElementDimension.left+draggedElementDimension.width,topHint.element.latestDimension.left+topHint.element.latestDimension.width);
        let top;
        if(position=="top")
            top=draggedElementDimension.top;
        else
            top=draggedElementDimension.top+draggedElementDimension.height;
        top-=topHint.delta;
        let $rule=jQuery(`<div style="position: absolute;height:1px;border-top:dashed #66CCFF 1px;width:${endLeft-startLeft}px;top:${top}px;left:${startLeft}px"></div>`);
        jQuery('body').append($rule);
        return $rule;
    }

    private ShowHorizontalHint(position:'left'|'right',$element:JQuery,draggedElementDimension: Dimension, leftHint: HintInformation) {
        let startTop=Math.min(draggedElementDimension.top,leftHint.element.latestDimension.top);
        let endTop=Math.max(draggedElementDimension.top+draggedElementDimension.height,leftHint.element.latestDimension.top+leftHint.element.latestDimension.height);
        let left;
        if(position=="left")
            left=draggedElementDimension.left;
        else
            left=draggedElementDimension.left+draggedElementDimension.width;
        left-=leftHint.delta;
        let $rule=jQuery(`<div style="position: absolute;width:1px;border-left:dashed #66CCFF 1px;height:${endTop-startTop}px;left:${left}px;top:${startTop}px"></div>`);
        jQuery('body').append($rule);
        return $rule;
    }

    public Clear() {
        if(this.$topHint!=null)
            this.$topHint.remove();
        if(this.$bottomHint!=null)
            this.$bottomHint.remove();

        if(this.$rightHint!=null)
            this.$rightHint.remove();
        if(this.$leftHint!=null)
            this.$leftHint.remove();
    }
}

interface HintInformation{
    element:PDFControlBase;
    delta:number;
}